import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

declare var bootstrap: any;

@Component({
  selector: 'app-escritorios',
  templateUrl: './escritorios.component.html',
  styleUrls: ['./escritorios.component.css']
})
export class EscritoriosComponent implements OnInit, AfterViewInit {
  isOK = false;

  @ViewChild('upload1')
  file1!: ElementRef;
  @ViewChild('upload2')
  file2!: ElementRef;
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm: cadastroData = {
    loading: false,
    data: {
      nome: '',
      certificado: '',
      senha: '',
      procuracoes: []
    }
  }

  modalCadastrar: any;

  editarFrm: editarData = {
    loading: false,
    data: {
      id: -1,
      nome: '',
      certificado: '1',
      senha: '',
      procuracoes: []
    }
  }

  modalEditar: any;

  atualizarCertificado = false;

  procuracoes = [
    {
      "status": false,
      "procuracao": "Todos os serviços existentes e os que vierem a ser disponibilizados no sistema de Procurações Eletrônicas do e-CAC (destinados ao tipo do Outorgante - PF ou PJ), para todos os fins, inclusive confissão de débitos, durante o período de validade da procuração."
    },
    {
      "status": false,
      "procuracao": "e-AssinaRFB"
    },
    {
      "status": false,
      "procuracao": "e-Financeira"
    },
    {
      "status": false,
      "procuracao": "eSocial - Download"
    },
    {
      "status": false,
      "procuracao": "eSocial - Download Doméstico"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo Acesso WEB"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo Desligamento"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo Especial"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo Preliminar"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo Rotinas"
    },
    {
      "status": false,
      "procuracao": "eSocial - Grupo SST"
    },
    {
      "status": false,
      "procuracao": "Acessar o sistema DCTFWeb"
    },
    {
      "status": false,
      "procuracao": "Acessar o Programa Especial de Regularização Tributária - PERT"
    },
    {
      "status": false,
      "procuracao": "Acessar o SERO - Serviço Eletrônico de Aferição de Obras"
    },
    {
      "status": false,
      "procuracao": "Acessar Programa Especial de Regularização Tributária - PERT - Débito Previdenciário"
    },
    {
      "status": false,
      "procuracao": "Acessar PER/DCOMP WEB"
    },
    {
      "status": false,
      "procuracao": "Aderir Modalidade de Parcelamento"
    },
    {
      "status": false,
      "procuracao": "Agendamento do SAGA"
    },
    {
      "status": false,
      "procuracao": "Aplicações PGFN - Parcelamento Simplificado"
    },
    {
      "status": false,
      "procuracao": "Aplicações PGFN - Requerimento para exclusão da Lista de Devedores"
    },
    {
      "status": false,
      "procuracao": "Assinatura da Escrituração Fiscal Digital - EFD ICMS IPI"
    },
    {
      "status": false,
      "procuracao": "Atualização de Dados Bancários"
    },
    {
      "status": false,
      "procuracao": "Cadastro CNPJ - Consulta Situação do Pedido"
    },
    {
      "status": false,
      "procuracao": "Caixa Postal - Mensagens"
    },
    {
      "status": false,
      "procuracao": "Caixa Postal - Termo de Opção pelo Domicílio Tributário Eletrônico"
    },
    {
      "status": false,
      "procuracao": "Compensação a pedido do Simples Nacional"
    },
    {
      "status": false,
      "procuracao": "Comunicação para Compensação de Ofício"
    },
    {
      "status": false,
      "procuracao": "Consulta Ação Fiscal do Simples Nacional"
    },
    {
      "status": false,
      "procuracao": "Consulta Pendências - Inclusão no Cadin/Sisbacen pela RFB"
    },
    {
      "status": false,
      "procuracao": "Consultar regularidade do profissional contábil - Envio ECD"
    },
    {
      "status": false,
      "procuracao": "Consultar Retenções do FPEM"
    },
    {
      "status": false,
      "procuracao": "Contribuinte Diferenciado - e-MAC (Sistema de Comunicação Eletrônica)"
    },
    {
      "status": false,
      "procuracao": "Contribuinte Diferenciado - Consulta Participação no Acompanhamento Diferenciado"
    },
    {
      "status": false,
      "procuracao": "Contribuinte Diferenciado - Pessoas de Contato"
    },
    {
      "status": false,
      "procuracao": "CHATRFB - Todos os serviços disponíveis no canal de atendimento"
    },
    {
      "status": false,
      "procuracao": "Cópia de Declaração"
    },
    {
      "status": false,
      "procuracao": "CNO - Cadastro Nacional de Obras"
    },
    {
      "status": false,
      "procuracao": "Declaração Simplificada de Pessoa Jurídica  (Empresas Inativas 2016)"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2007"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2008"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2009"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2010"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2011"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Jurídica - Inativas 2015"
    },
    {
      "status": false,
      "procuracao": "Declarações - Declaração Simplificada da Pessoa Juridica - Inativas 2014"
    },
    {
      "status": false,
      "procuracao": "Declarações - Dmed (Extrato)"
    },
    {
      "status": false,
      "procuracao": "Declarações - DCTF (Acesso ao conteúdo da declaração, extrato e 2a via do recibo)"
    },
    {
      "status": false,
      "procuracao": "Declarações - DIPJ/PJ Simplificada (Acesso ao conteúdo da declaração, extrato e 2a via do recibo)"
    },
    {
      "status": false,
      "procuracao": "Declarações - DIRF (Acesso ao conteúdo da declaração, extrato e 2a via do recibo)"
    },
    {
      "status": false,
      "procuracao": "Desistência de Parcelamentos Anteriores"
    },
    {
      "status": false,
      "procuracao": "Download da Escrituração Contábil Digital (SPED-ECD) utilizando o Receitanet Bx"
    },
    {
      "status": false,
      "procuracao": "Download da Escrituração Fiscal Digital (SPED-EFD) utilizando o Receitanet Bx"
    },
    {
      "status": false,
      "procuracao": "Download de EFD-PIS/Cofins através do ReceitaNetBX"
    },
    {
      "status": false,
      "procuracao": "Download do Controle Fiscal Contábil de Transição (SPED-FCONT) utilizando o Receitanet Bx"
    },
    {
      "status": false,
      "procuracao": "Download dos arquivos SPED Dados Agregados e Termos da ECD utilizando o ReceitanetBx"
    },
    {
      "status": false,
      "procuracao": "DERCAT - Declaração de Regularização Cambial e Tributária"
    },
    {
      "status": false,
      "procuracao": "DME - Declaração de Operações Liquidadas com Moeda em Espécie"
    },
    {
      "status": false,
      "procuracao": "E-DMOV - Declaração Aduaneira de Movimentação Física de Valores"
    },
    {
      "status": false,
      "procuracao": "Emissão de DAS da Parcela Mínima"
    },
    {
      "status": false,
      "procuracao": "Emissão de DAS Avulso"
    },
    {
      "status": false,
      "procuracao": "Entregar Arquivo de Dados - Obrigação Acessória"
    },
    {
      "status": false,
      "procuracao": "Extrato Malha Fiscal Pessoa Jurídica"
    },
    {
      "status": false,
      "procuracao": "EFD - Reinf - Geral"
    },
    {
      "status": false,
      "procuracao": "EFD-REINF RH-Perfil Recursos Humanos"
    },
    {
      "status": false,
      "procuracao": "Fontes Pagadoras"
    },
    {
      "status": false,
      "procuracao": "Formulário Dcide-Combustíveis"
    },
    {
      "status": false,
      "procuracao": "Intimação DCTF"
    },
    {
      "status": false,
      "procuracao": "Isenções e Regimes Especiais"
    },
    {
      "status": false,
      "procuracao": "Matrícula CEI"
    },
    {
      "status": false,
      "procuracao": "Notificações e Autos relativos à entrega de declarações"
    },
    {
      "status": false,
      "procuracao": "Notificações em Auditoria de Compensação em GFIP"
    },
    {
      "status": false,
      "procuracao": "Paex - Lei 13.988 - Transacionar Contencioso de Pequeno Valor"
    },
    {
      "status": false,
      "procuracao": "Pagamento e Parcelamento Lei nº 12.996/2014"
    },
    {
      "status": false,
      "procuracao": "Pagamentos - Comprovante de Arrecadação"
    },
    {
      "status": false,
      "procuracao": "Pagamentos - Retificação de Documento de Arrecadação - Redarf Net"
    },
    {
      "status": false,
      "procuracao": "Parcelamento - Microempreendedor Individual"
    },
    {
      "status": false,
      "procuracao": "Parcelamento - Solicitar e acompanhar"
    },
    {
      "status": false,
      "procuracao": "Parcelamento de Débitos"
    },
    {
      "status": false,
      "procuracao": "Parcelamento de Débitos do Simples Nacional"
    },
    {
      "status": false,
      "procuracao": "Parcelamento Especial - Microempreendedor Individual"
    },
    {
      "status": false,
      "procuracao": "Parcelamento Especial - Opções da Lei 11.941/2009"
    },
    {
      "status": false,
      "procuracao": "Parcelamento Especial Simples Nacional"
    },
    {
      "status": false,
      "procuracao": "Parcelamento Simplificado Previdenciário"
    },
    {
      "status": false,
      "procuracao": "Parcelamento Simplificado Previdenciário DAU"
    },
    {
      "status": false,
      "procuracao": "Parcelar dívidas do MEI pela LC 193/2022 (RELP)"
    },
    {
      "status": false,
      "procuracao": "Parcelar dívidas do SN pela LC 193/2022 (RELP)"
    },
    {
      "status": false,
      "procuracao": "Pedido Eletrônico de Restituição (Simples e Simei)"
    },
    {
      "status": false,
      "procuracao": "Processos Digitais"
    },
    {
      "status": false,
      "procuracao": "Programa de Regularização Tributária-Débitos Previdenciários"
    },
    {
      "status": false,
      "procuracao": "Programa de Regularização Tributária-Demais Débitos"
    },
    {
      "status": false,
      "procuracao": "Programa Especial de Regularização Tributária - PERT-MEI"
    },
    {
      "status": false,
      "procuracao": "Programa Especial Regularização Tributária - PERT-SN"
    },
    {
      "status": false,
      "procuracao": "PER/DCOMP - Consulta Análise Preliminar/Autorregularização"
    },
    {
      "status": false,
      "procuracao": "PER/DCOMP - Consulta Despacho Decisório"
    },
    {
      "status": false,
      "procuracao": "PER/DCOMP - Consulta Intimação"
    },
    {
      "status": false,
      "procuracao": "PER/DCOMP - Consulta Processamento"
    },
    {
      "status": false,
      "procuracao": "PGDAS-D - a partir de 01/2018"
    },
    {
      "status": false,
      "procuracao": "PGF - Consulta Débitos inscritos a partir de 01/11/2012"
    },
    {
      "status": false,
      "procuracao": "PGFN - Consulta Débitos inscritos a partir de 01/11/2012"
    },
    {
      "status": false,
      "procuracao": "PGMEI - Programa Gerador do MEI"
    },
    {
      "status": false,
      "procuracao": "Reabertura Pagamento e Parcelamento Lei nº 11.941/2009"
    },
    {
      "status": false,
      "procuracao": "Recuperação de Ajustes/Saldos do Controle Fiscal Contábil de Transição (FCONT)"
    },
    {
      "status": false,
      "procuracao": "Refri - Termo de Opção"
    },
    {
      "status": false,
      "procuracao": "Retificação de GPS."
    },
    {
      "status": false,
      "procuracao": "RECOB - Regime Especial de Apuração e Pagamento da Contribuição para o PIS/PASEP e COFINS"
    },
    {
      "status": false,
      "procuracao": "Sief Cobrança - Intimações DCTF"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Acompanhamento Opção"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Agendamento de Opção"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Alerta - Avisos e comunicações para o contribuinte"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Cancelamento da Solicitação da Opção"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Cancelamento do Agendamento da Opção"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Consulta Débitos Sivex"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Consulta Declaração Transmitida"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Declaração do Simples Nacional - 2007 e 2008"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Emissão de DAS de Auto de Infração"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Exclusão do Simples Nacional"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Gerador de Documento de Arrecadação"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Opção pelo Regime de Apuração de Receitas"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - PGDAS-D - a partir de 01/2012"
    },
    {
      "status": false,
      "procuracao": "Simples Nacional - Solicitação Opção"
    },
    {
      "status": false,
      "procuracao": "Sistema de Ajuste de Documentos de Arrecadação - SISTAD"
    },
    {
      "status": false,
      "procuracao": "Sistema de Leilão Eletrônico"
    },
    {
      "status": false,
      "procuracao": "Sistema de Medição de Vazão"
    },
    {
      "status": false,
      "procuracao": "Situação Fiscal do Contribuinte"
    },
    {
      "status": false,
      "procuracao": "Solicitar, acompanhar e emitir DAS de parcelamento"
    },
    {
      "status": false,
      "procuracao": "SISCOSERV - Sistema Integrado de Comércio Exterior e Serviços"
    },
    {
      "status": false,
      "procuracao": "SPED ECD - Central de Balanços."
    },
    {
      "status": false,
      "procuracao": "SPED-ECF (Escrituração Contábil Fiscal)"
    },
    {
      "status": false,
      "procuracao": "SPED-ECF-Download - Download via ReceitanetBX da Escrituração Contábil Fiscal"
    },
    {
      "status": false,
      "procuracao": "Transmissão de Declarações/Arquivos, inclusive todos do CNPJ, com Assinatura Digital via Receitanet"
    }
  ]

  filtro: string = '';

  constructor(public userService: UserService, private router: Router, private elem: ElementRef) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('6')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'escritorios-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [5] },
        { "orderable": false, "targets": [5] },
      ],
      order: [[1, 'asc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchEscritorio(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = 'Editar';
          }
          call();
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', () => {
          this.Excluir(Number(id));
        });
        return row;
      },
    }
  }

  ngAfterViewInit(): void {
    if (this.isOK) {
      this.modalCadastrar = new bootstrap.Modal(
        document.getElementById('cadastrar'),
        {
          backdrop: 'static',
        }
      );

      this.modalEditar = new bootstrap.Modal(
        document.getElementById('editar'),
        {
          backdrop: 'static',
        }
      );
    }
  }

  handleUpload(event: Event, from: Number) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length) {
      const file = target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (from == 0) {
            this.cadastroFrm.data.certificado = reader.result as string;
            this.cadastroFrm.data.certificado = this.cadastroFrm.data.certificado.split(',')[1];
          } else {
            this.editarFrm.data.certificado = reader.result as string;
            this.editarFrm.data.certificado = this.editarFrm.data.certificado.split(',')[1];
          }
        };
      } else {
        if (from == 0) {
          this.cadastroFrm.data.certificado = '';
        } else {
          this.editarFrm.data.certificado = '';
        }
      }
    }
  }

  openModalCadastrar() {
    for (const index of this.procuracoes) {
      index.status = false;
    }
    this.modalCadastrar.show()
  }

  Cadastrar() {
    this.filtro = '';
    this.cadastroFrm.data.procuracoes = [];

    for (const index of this.procuracoes) {
      if (index.status) {
        this.cadastroFrm.data.procuracoes.push(index.procuracao);
      }
    }

    this.cadastroFrm.loading = true;
    this.userService
      .cadastrarEscritorio(
        this.cadastroFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Escritório cadastrado',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.cadastroFrm.data = {
            nome: '',
            certificado: '',
            senha: '',
            procuracoes: []
          };
          this.file1.nativeElement.value = "";
          this.modalCadastrar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.cadastroFrm.loading = false
        },
        () => (this.cadastroFrm.loading = false)
      );
  }

  fetchEscritorio(id: number) {
    this.filtro = '';
    this.editarFrm.loading = true;
    return new Promise((resolve) => {
      this.userService.fetchEscritorio(id).subscribe(
        (res: any) => {
          this.editarFrm.data = res;
          this.editarFrm.data.certificado = '';
          this.atualizarCertificado = false;

          for (const index of this.procuracoes) {
            index.status = false;
          }

          for (const index of res.procuracoes) {
            for (const index2 of this.procuracoes) {
              if (index2.procuracao === index) {
                index2.status = true;
                break;
              }
            }
          }

          this.modalEditar.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      ).add(() => {
        resolve('');
      });
    });
  }

  Editar() {
    this.editarFrm.data.procuracoes = [];

    for (const index of this.procuracoes) {
      if (index.status) {
        this.editarFrm.data.procuracoes.push(index.procuracao);
      }
    }

    this.editarFrm.loading = true;
    this.userService
      .editarEscritorio(
        this.editarFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Escritório editado',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.modalEditar.hide();
          if (this.file2) {
            this.file2.nativeElement.value = "";
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });

          let tmp = this.userService.getEscritorio();
          if (tmp![0] === this.editarFrm.data.id) {
            if (tmp![1] !== this.editarFrm.data.nome) {
              this.userService.setEscritorio(tmp![0], this.editarFrm.data.nome)
            }
          }
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      );
  }

  Excluir(id: number) {
    Swal.fire({
      title: 'Excluir Escritório?',
      icon: 'warning',
      text: 'Este processo é irreversível',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.excluirEscritorio(id).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: 'Escritório excluído',
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }

  changed = (evt: any) => {
    this.procuracoes[evt.target.value].status = evt.target.checked
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    nome: string;
    certificado: string;
    senha: string;
    procuracoes: string[];
  }
}

export interface editarData {
  loading: boolean;
  data: {
    id: Number;
    nome: string;
    certificado: string;
    senha: string;
    procuracoes: string[];
  }
}
